(function () {
  const pad = (num) => String(Math.max(0, num)).padStart(2, "0");

  const parseTarget = (value) => {
    if (!value) return null;
    const normalized = value.trim().replace(" ", "T");
    const date = new Date(normalized);
    return isNaN(date.getTime()) ? null : date;
  };

  const setUnits = (el, days, hours, minutes, seconds) => {
    const daysEl = el.querySelector("[data-countdown-days]");
    const hoursEl = el.querySelector("[data-countdown-hours]");
    const minutesEl = el.querySelector("[data-countdown-minutes]");
    const secondsEl = el.querySelector("[data-countdown-seconds]");

    if (daysEl) daysEl.textContent = pad(days);
    if (hoursEl) hoursEl.textContent = pad(hours);
    if (minutesEl) minutesEl.textContent = pad(minutes);
    if (secondsEl) secondsEl.textContent = pad(seconds);
  };

  const handleExpired = (el) => {
    setUnits(el, 0, 0, 0, 0);

    if (el.dataset.expiredBehavior === "hide") {
      el.setAttribute("hidden", "hidden");
      return;
    }

    const unitsEl = el.querySelector(".hero-countdown__timer-units");
    const messageEl = el.querySelector("[data-countdown-expired-message]");
    if (unitsEl) unitsEl.setAttribute("hidden", "hidden");
    if (messageEl) messageEl.removeAttribute("hidden");
  };

  const tick = (el, target) => {
    const diff = target.getTime() - Date.now();

    if (diff <= 0) {
      handleExpired(el);
      return false;
    }

    const totalSeconds = Math.floor(diff / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    setUnits(el, days, hours, minutes, seconds);
    return true;
  };

  const timers = new WeakMap();

  const initCountdown = (el) => {
    if (!el || timers.has(el)) return;

    const target = parseTarget(el.dataset.endDatetime);
    if (!target) {
      el.setAttribute("hidden", "hidden");
      return;
    }

    const stillRunning = tick(el, target);
    if (!stillRunning) return;

    const intervalId = setInterval(() => {
      const running = tick(el, target);
      if (!running) {
        clearInterval(intervalId);
        timers.delete(el);
      }
    }, 1000);

    timers.set(el, intervalId);
  };

  const destroyCountdown = (el) => {
    const intervalId = timers.get(el);
    if (intervalId) {
      clearInterval(intervalId);
      timers.delete(el);
    }
  };

  const initAll = (root) => {
    (root || document)
      .querySelectorAll("[data-hero-countdown]")
      .forEach(initCountdown);
  };

  const destroyAll = (root) => {
    (root || document)
      .querySelectorAll("[data-hero-countdown]")
      .forEach(destroyCountdown);
  };

  if (document.readyState !== "loading") {
    initAll();
  } else {
    document.addEventListener("DOMContentLoaded", () => initAll());
  }

  document.addEventListener("shopify:section:load", (event) => initAll(event.target));
  document.addEventListener("shopify:section:unload", (event) => destroyAll(event.target));
})();
